export function ensureHTTP(url: string) {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

export function getUrlLastSegment(url: string) {
  if (!url) return null;
  try {
    const segments = new URL(url).pathname.split('/');
    return segments.pop() || segments.pop();
  } catch {
    return null;
  }
}

export function getHostName(url: string) {
  if (!url) return null;

  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}
